import styled from 'styled-components';

import { purpurFocus } from '@telialt/common-theme/src/mixins';
import {
    getPurpurColor,
    getPurpurSpacing,
    getPurpurTypography,
    purpurMedia,
} from '@telialt/common-theme/src/purpurSelectors';

type WrapperProps = {
    $isMobileVisible?: boolean;
};

export const SalonListWrapper = styled.div<WrapperProps>`
    display: ${({ $isMobileVisible }) => ($isMobileVisible ? 'flex' : 'none')};
    padding-top: ${getPurpurSpacing('300')};
    padding-bottom: ${getPurpurSpacing('300')};

    ${purpurMedia('xl')`
        display: flex;
    `};
`;

export const SalonListContainer = styled.div`
    width: 100%;
`;

export const SalonItemContainer = styled.button`
    border: 1px solid #ccc;
    padding: 0 ${getPurpurSpacing('300')};
    border-radius: 0.5rem;
    cursor: pointer;
    margin-top: ${getPurpurSpacing('150')};
    text-align: left;
    width: 100%;
    min-height: 4.5rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: ${getPurpurSpacing('200')};

    ${purpurFocus()};

    &:hover {
        background: #fafafa;
        color: ${getPurpurColor('purple500')};
    }
`;

export const SalonItemTitle = styled.div`
    font-size: 0.875rem;
    font-weight: ${getPurpurTypography('weightBold')};
`;
